<script>
import appConfig from "@/app.config.json";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";
import user from "@/mixins/user";

export default {
  mixins: [ DeviceDetectionMixin ,user],
  page: {
    title: "SSO-callback",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  async mounted() {
    // クエリパラメータからアクセストークンと user 情報を取得
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const user = params.get('user') || {};
    const resultLogin = await this.$store.dispatch("auth/ssoLogin", {
      token: token,
      user: JSON.parse(user)
    });

    if (resultLogin.status) {
      let rootScreenUrl = this.getRootScreenUrl();
      this.$router.push({ path: rootScreenUrl });
      return;
    } else {
      console.log('sso-callback.vue 401');
      this.$router.push({ name: "401" });
    }

  }
};
</script>

<template>

</template>